import _ from 'lodash'

class PasswordResetService {
  constructor(
    $http,
    $log,
    $location,
    config,
    $window,
    $analytics,
    Reset
  ) {
    this.$log = $log
    this.$http = $http
    this.$location = $location
    this.$window = $window
    this.$analytics = $analytics
    this.Reset = Reset
  }

  requestResetPasswordEmail(
    email,
    successCallback,
    failureCallback
    ) {
    this.Reset.generate(
        { email: email },
        response => this._onEmailGenerated(response, successCallback),
        response => this._onEmailFailed(response, failureCallback)
      )
  }

  _onEmailGenerated(response, callback = function(){}) {
    this.$log.debug('success', response)
    callback(response)
  }

  _onEmailFailed(response, callback = function(){}) {
    this.$log.debug('failure', response)
    callback(response)
  }

  validateResetToken(token) {
    this.Reset.validate(
        { token: token },
        response => {
          this.validToken = true,
          this.token = token
        },
        response => {
          this.validToken = false
        }
      )
  }

  get validReset() {
    return this.validToken
  }

  sendNewPassword(password, successCallback, failureCallback) {
    this.Reset.change(
        { token: this.token, password: password },
        response => successCallback(response),
        response => failureCallback(response)
      )
  }
}

PasswordResetService.$inject = [
  '$http',
  '$log',
  '$location',
  'config',
  '$window',
  '$analytics',
  'Reset'
]

export default PasswordResetService
